import WelcomeDone from '@/screens/WelcomeDone';

export default function PrivateWelcomeDoneRoute() {
  return <WelcomeDone />;
}
